import React from 'react';
import { Eye, Edit, Trash2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
export function EmailDetails() {
  const emails = [{
    id: 1,
    subject: 'Welcome to Desert Sage',
    body: 'Thank you for registering...',
    created: '2023-01-01',
    status: 'Active'
  }, {
    id: 2,
    subject: 'Course Completion',
    body: 'Congratulations on completing...',
    created: '2023-01-01',
    status: 'Active'
  }, {
    id: 3,
    subject: 'Password Reset',
    body: 'Click here to reset...',
    created: '2023-01-01',
    status: 'Inactive'
  }];
  return <div className="space-y-6" data-id="element-352">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-353">Email Details</h1>

      <Card className="overflow-hidden" data-id="element-354">
        <div className="overflow-x-auto" data-id="element-355">
          <table className="w-full text-sm text-left" data-id="element-356">
            <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-357">
              <tr data-id="element-358">
                <th className="px-4 py-3" data-id="element-359">Id</th>
                <th className="px-4 py-3" data-id="element-360">Subject</th>
                <th className="px-4 py-3" data-id="element-361">Body</th>
                <th className="px-4 py-3" data-id="element-362">Created</th>
                <th className="px-4 py-3" data-id="element-363">Status</th>
                <th className="px-4 py-3" data-id="element-364">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-365">
              {emails.map(email => <tr key={email.id} className="hover:bg-slate-50" data-id="element-366">
                  <td className="px-4 py-3 text-slate-500" data-id="element-367">{email.id}</td>
                  <td className="px-4 py-3 font-medium" data-id="element-368">{email.subject}</td>
                  <td className="px-4 py-3 text-slate-500 truncate max-w-xs" data-id="element-369">
                    {email.body}
                  </td>
                  <td className="px-4 py-3 text-slate-500" data-id="element-370">{email.created}</td>
                  <td className="px-4 py-3" data-id="element-371">
                    <Badge variant={email.status === 'Active' ? 'success' : 'secondary'} data-id="element-372">
                      {email.status}
                    </Badge>
                  </td>
                  <td className="px-4 py-3" data-id="element-373">
                    <div className="flex items-center gap-2" data-id="element-374">
                      <Button variant="ghost" size="icon" title="View" data-id="element-375">
                        <Eye className="h-4 w-4 text-slate-500" data-id="element-376" />
                      </Button>
                      <Button variant="ghost" size="icon" title="Edit" data-id="element-377">
                        <Edit className="h-4 w-4 text-blue-600" data-id="element-378" />
                      </Button>
                      <Button variant="ghost" size="icon" title="Delete" data-id="element-379">
                        <Trash2 className="h-4 w-4 text-red-600" data-id="element-380" />
                      </Button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}